export default __webpack_public_path__ + "static/media/ambulance.05200c14.svg";